import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createProduct } from '../services/products.api';
import type { CreateProductDTO } from '../types';

export function useCreateProduct() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateProductDTO) => createProduct(data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['products', 'list'] });
    },
  });
}
